import { DOCUMENT } from '@angular/common';
import { Router, NavigationEnd } from '@angular/router';
import {
  Component,
  Inject,
  ElementRef,
  OnInit,
  Renderer2,
  HostListener,
  OnDestroy
} from '@angular/core';
import { ROUTES } from './sidebar-items';
import { AuthService } from 'src/app/core/service/auth.service';
import { BehaviorSubject } from 'rxjs';
import { User } from 'src/app/core/models/user';
import { BaseService } from 'src/app/core/service/base.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';

declare const Waves: any;
@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit, OnDestroy {
  public sidebarItems: any[];
  level1Menu = '';
  level2Menu = '';
  level3Menu = '';
  public innerHeight: any;
  public bodyTag: any;
  listMaxHeight: string;
  listMaxWidth: string;
  headerHeight = 60;
  routerObj = null;


  constructor(
    @Inject(DOCUMENT) private document: Document,
    private renderer: Renderer2,
    public elementRef: ElementRef,
    public authService: AuthService,
    private router: Router,
    public baseService: BaseService,
    private http: HttpClient,
  ) {

    this.authService.currentUserSubject = new BehaviorSubject<User>(
      JSON.parse(localStorage.getItem('user'))
    );
    this.authService.user = JSON.parse(localStorage.getItem('user'));
    this.routerObj = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        // logic for select active menu in dropdown
        const currenturl = event.url.split('?')[0];
        this.level1Menu = currenturl.split('/')[1];
        this.level2Menu = currenturl.split('/')[2];

        // close sidebar on mobile screen after menu select
        this.renderer.removeClass(this.document.body, 'overlay-open');
      }
    });
  }

  @HostListener('window:resize', ['$event'])
  windowResizecall(event) {
    this.setMenuHeight();
    this.checkStatuForResize(false);
  }

  @HostListener('document:mousedown', ['$event'])
  onGlobalClick(event): void {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.renderer.removeClass(this.document.body, 'overlay-open');
    }
  }
  callLevel1Toggle(event: any, element: any) {
    // this.reload()

    if (element && element === this.level1Menu) {
      this.level1Menu = '0';
    } else {
      this.level1Menu = element;
    }
    const hasClass = event.target.classList.contains('toggled');
    if (hasClass) {
      this.renderer.removeClass(event.target, 'toggled');
    } else {
      this.renderer.addClass(event.target, 'toggled');
    }
  }
  callLevel2Toggle(event: any, element: any) {
    // this.reload()
    if (element && element === this.level2Menu) {
      this.level2Menu = '0';
    } else {
      this.level2Menu = element;
    }
  }
  callLevel3Toggle(event: any, element: any) {
    if (element === this.level3Menu) {
      this.level3Menu = '0';
    } else {
      this.level3Menu = element;
    }
  }
  ngOnInit() {
    if (this.authService.currentUserValue) {
      this.baseService.blockStart();
      let mySchools: any;
      const token = localStorage.getItem('token');
      const header = new HttpHeaders().set('x-access-token', token);
      this.http.get<any>(this.baseService.apiUrl + '/school/', { headers: header })
        .subscribe(data => {

           
          mySchools = data.data;
          //  localStorage.setItem('routeMenuItems', JSON.stringify(data.data));
        },
          error => {
            this.baseService.blockStop();
            console.log(error);
          },
          () => {
            for (let i = 0; i < mySchools.length; i++) {
              if (mySchools[i].isDefault == "1")
                // this.defaultSchool=this.mySchools[i].name;
                this.baseService.schoolId = mySchools[i].id;
            }


            this.http.get<any>(this.baseService.apiUrl + 'getMenusChildren/' + this.baseService.schoolId, { headers: header })
            .subscribe(data => {
              this.baseService.blockStop();
               
              this.baseService.sidebarItems = data.data;
              console.log(data)
              // localStorage.setItem('routeMenuItems', JSON.stringify(data.data));
            },
              error => {
                this.baseService.blockStop();
                console.log(error);
              });
          });

      // this.sidebarItems = ROUTES.filter((sidebarItem) => sidebarItem);
      //  this.base.sidebarItems = JSON.parse(localStorage.getItem('routeMenuItems'))
      // this.sidebarItems = JSON.parse(localStorage.getItem('routeMenuItems'))

      // this.sidebarItems = JSON.parse(this.base.sidebarItems);


      // const hasClass = this.document.body.classList.contains('side-closed');
      // const bigLogo = this.document.getElementById('big-Logo')
      // const smallLogo = this.document.getElementById('small-Logo')
      // if (!hasClass) {
      //   this.renderer.addClass(this.document.body, 'side-closed');
      //   this.renderer.addClass(this.document.body, 'submenu-closed');
      //   this.renderer.removeClass(bigLogo, 'show-logo');
      //   this.renderer.removeClass(smallLogo, 'hide-logo');
      //   this.renderer.addClass(bigLogo, 'hide-logo');
      //   this.renderer.addClass(smallLogo, 'show-logo');
      // }


    }
    this.initLeftSidebar();
    this.bodyTag = this.document.body;
  }
  ngOnDestroy() {
    this.routerObj.unsubscribe();
    // this.sidebarItems = JSON.parse(localStorage.getItem('routeMenuItems'))

  }
  initLeftSidebar() {
    const _this = this;
    // Set menu height
    _this.setMenuHeight();
    _this.checkStatuForResize(true);
  }
  setMenuHeight() {
    this.innerHeight = window.innerHeight;
    const height = this.innerHeight - this.headerHeight;
    this.listMaxHeight = height + '';
    this.listMaxWidth = '500px';
  }
  isOpen() {
    return this.bodyTag.classList.contains('overlay-open');
  }
  checkStatuForResize(firstTime) {
    if (window.innerWidth < 1170) {
      this.renderer.addClass(this.document.body, 'ls-closed');
    } else {
      this.renderer.removeClass(this.document.body, 'ls-closed');
    }
  }

  mouseHover(e) {


    const body = this.elementRef.nativeElement.closest('body');
    const bigLogo = this.document.getElementById('big-Logo')
    const smallLogo = this.document.getElementById('small-Logo')

    if (body.classList.contains('submenu-closed')) {
      this.reload()
      this.renderer.addClass(this.document.body, 'side-closed-hover');
      this.renderer.removeClass(this.document.body, 'submenu-closed');


      this.renderer.removeClass(bigLogo, 'hide-logo');
      this.renderer.removeClass(smallLogo, 'show-logo');
      this.renderer.addClass(bigLogo, 'show-logo');
      this.renderer.addClass(smallLogo, 'hide-logo');
    }
    // this.sidebarItems = JSON.parse(localStorage.getItem('routeMenuItems'))
  }
  mouseOut(e) {
    // this.reload()

    const body = this.elementRef.nativeElement.closest('body');
    const bigLogo = this.document.getElementById('big-Logo')
    const smallLogo = this.document.getElementById('small-Logo')

    if (body.classList.contains('side-closed-hover')) {
      this.renderer.removeClass(this.document.body, 'side-closed-hover');
      this.renderer.addClass(this.document.body, 'submenu-closed');

      this.renderer.removeClass(bigLogo, 'show-logo');
      this.renderer.removeClass(smallLogo, 'hide-logo');
      this.renderer.addClass(bigLogo, 'hide-logo');
      this.renderer.addClass(smallLogo, 'show-logo');
    }
    // this.sidebarItems = JSON.parse(localStorage.getItem('routeMenuItems'))

  }
  reload() {
    // window.onload
    // this.base.sidebarItems = JSON.parse(localStorage.getItem('routeMenuItems'))
    this.sidebarItems = JSON.parse(localStorage.getItem('routeMenuItems'))

    // console.log(this.sidebarItems)
  }

}
